export default __webpack_public_path__ + "04186a406c8389e5209d8c024e1b42e7.ttf";